// extracted by mini-css-extract-plugin
export default {"greyContainer":"GreyContainer_greyContainer__ZZ8cv"};